export default __webpack_public_path__ + "static/automobile-3d-expandable-carousel-2565abeb33d6b6d91b784ccaffe54fd6.gif";